import { useState, useEffect } from 'react';

export type Language = 'sr';

export const useLanguage = () => {
  const [language, setLanguage] = useState<Language>('sr');

  useEffect(() => {
    // Always set to Serbian
    setLanguage('sr');
    document.documentElement.lang = 'sr';
    document.title = 'Hot Dogs - Salon za pse | Frizerski salon za pse Beograd | Šišanje i grooming';
  }, []);

  // Remove toggle functionality - always return Serbian
  const toggleLanguage = () => {
    // Do nothing - language is fixed to Serbian
  };

  return { language, toggleLanguage };
};